export type PersonalizationQuestionType = {
  order: number;
  id: string;
  question: string;
  subhead: string;
  type: 'short_answer' | 'single_choice' | 'multi_select' | 'free_response';
  choices?: string[];
};

export const YEARS_TEACHING_PROMPT: PersonalizationQuestionType = {
  id: 'yearsTeaching',
  order: 1,
  question: 'How many years have you been teaching?',
  subhead:
    'CodeAI has tools and resources for teachers at every stage of their teaching journey.',
  type: 'short_answer',
  choices: [],
};

export const CONFIDENCE_PROMPT: PersonalizationQuestionType = {
  id: 'confidence',
  order: 2,
  question: 'How confident are you in teaching programming concepts?',
  subhead:
    'No matter your level of experience, CodeAI can help you teach computer science.',
  type: 'single_choice',
};

export const TEACHER_GOAL_PROMPT: PersonalizationQuestionType = {
  id: 'goals',
  order: 3,
  question:
    "What goals do you have for your own teaching practice while using CodeAI's curriculum this year?",
  subhead: "CodeAI's teacher tools are designed to help you achieve them.",
  type: 'multi_select',
  choices: [
    'Become more confident in teaching new concepts',
    'Develop effective assessment & instructional strategies',
    'Support a variety of learners in my classroom',
    'Improve student engagement and learning outcomes',
    'Other',
  ],
};

export const CLASSROOM_VISION_PROMPT: PersonalizationQuestionType = {
  id: 'classroomVision',
  order: 4,
  question:
    'What do you want your classroom to look like, feel like, sound like?',
  subhead:
    "CodeAI's flexible course offerings offer a perfect fit for every classroom.",
  type: 'free_response',
};

export const SUPPORT_PREFERENCES_PROMPT: PersonalizationQuestionType = {
  id: 'support',
  order: 5,
  question: 'What kind of support is most helpful to you?',
  subhead:
    'CodeAI offers tools and resources to support professional learning for every educator.',
  type: 'multi_select',
  choices: [
    'Interactive examples or practice activities (hands-on)',
    'Quick reference guides (text-based, concise)',
    'Short videos with explanations or examples (visual)',
    'Articles or tutorials (More detailed, text-based)',
    'Other',
  ],
};

export const CHALLENGE_PROMPT: PersonalizationQuestionType = {
  id: 'challenge',
  order: 6,
  question:
    "What's the biggest challenge you anticipate while teaching computer science this year?",
  subhead:
    'CodeAI offers resources, training, and a teacher community to support you through any challenge.',
  type: 'free_response',
};

export const PERSONALIZATION_PROMPTS = [
  YEARS_TEACHING_PROMPT,
  CONFIDENCE_PROMPT,
  TEACHER_GOAL_PROMPT,
  CLASSROOM_VISION_PROMPT,
  SUPPORT_PREFERENCES_PROMPT,
  CHALLENGE_PROMPT,
];
